import { DoorsFormState, VenueFormState } from "company/detail/components/models";
import { MergeFormSection } from "components/MainSectionTemplate/types";
import React from "react";
import { isNullOrEmptyString } from "shared/utils";
import Doors from "venue/components/Doors";
import Stage from "venue/components/Stage";

export const venueDetailsSection = (
  venueSectionHidden: boolean,
  existingVenue: VenueFormState,
  sourceVenue: VenueFormState,
  currentVenue: VenueFormState,
  setCurrentVenue: (venue: VenueFormState) => void
): MergeFormSection => ({
  key: "venueDetails",
  title: site.currentEnvironment.functionGroups.venue.singular,
  hidden: venueSectionHidden,
  fields: [{
    key: "capacity",
    label: RESX.Venue.Capacity,
    currentValue: currentVenue.capacity,
    existingValue: existingVenue.capacity,
    sourceValue: sourceVenue.capacity,
    isEmpty: (v: number) => !v,
    render: (v: number) => <span>{v} PAX</span>,
    onSourceClick: () => setCurrentVenue({
      ...currentVenue,
      capacity: sourceVenue.capacity,
    }),
    onExistingClick: () => setCurrentVenue({
      ...currentVenue,
      capacity: existingVenue.capacity,
    }),
  }, {
    key: "ageRestriction",
    label: RESX.Venue.AgeRestrictions,
    currentValue: currentVenue.ageRestriction,
    existingValue: existingVenue.ageRestriction,
    sourceValue: sourceVenue.ageRestriction,
    isEmpty: (v: server.dto.AgeRestriction) => v.value === "unknown",
    render: (v: server.dto.AgeRestriction) => <span>{v.text}</span>,
    onSourceClick: () => setCurrentVenue({
      ...currentVenue,
      ageRestriction: sourceVenue.ageRestriction,
    }),
    onExistingClick: () => setCurrentVenue({
      ...currentVenue,
      ageRestriction: existingVenue.ageRestriction,
    }),
  }, {
    key: "doors",
    label: RESX.Venue.Doors,
    currentValue: currentVenue.doors,
    existingValue: existingVenue.doors,
    sourceValue: sourceVenue.doors,
    isEmpty: (v: DoorsFormState) => !v.open && !v.close,
    render: (v: DoorsFormState) => <Doors doors={v} />,
    onSourceClick: () => setCurrentVenue({
      ...currentVenue,
      doors: sourceVenue.doors,
    }),
    onExistingClick: () => setCurrentVenue({
      ...currentVenue,
      doors: existingVenue.doors,
    }),
  }, {
    key: "category",
    label: RESX.Venue.Category,
    currentValue: currentVenue.category,
    existingValue: existingVenue.category,
    sourceValue: sourceVenue.category,
    isEmpty: (v: server.dto.VenueCategory) => v.value === "unknown",
    render: (v: server.dto.VenueCategory) => <span>{v.text || ""}</span>,
    onSourceClick: () => setCurrentVenue({
      ...currentVenue,
      category: sourceVenue.category,
    }),
    onExistingClick: () => setCurrentVenue({
      ...currentVenue,
      category: existingVenue.category,
    }),
  }, {
    key: "stage",
    label: RESX.Venue.Stage,
    currentValue: currentVenue.stage,
    existingValue: existingVenue.stage,
    sourceValue: sourceVenue.stage,
    isEmpty: (stage: server.dto.Stage) => !stage.depth && !stage.width && !stage.toFloor && !stage.toCeiling,
    render: (stage: server.dto.Stage) => <Stage stage={stage} />,
    onSourceClick: () => setCurrentVenue({
      ...currentVenue,
      stage: sourceVenue.stage,
    }),
    onExistingClick: () => setCurrentVenue({
      ...currentVenue,
      stage: existingVenue.stage,
    }),
  }, {
    key: "vehicleAccess",
    label: RESX.Venue.VehicleAccess,
    currentValue: currentVenue.vehicleAccess,
    existingValue: existingVenue.vehicleAccess,
    sourceValue: sourceVenue.vehicleAccess,
    isEmpty: (v: string) => isNullOrEmptyString(v),
    render: (v: string) => <span>{v}</span>,
    onSourceClick: () => setCurrentVenue({
      ...currentVenue,
      vehicleAccess: sourceVenue.vehicleAccess,
    }),
    onExistingClick: () => setCurrentVenue({
      ...currentVenue,
      vehicleAccess: existingVenue.vehicleAccess,
    }),
  }, {
    key: "parking",
    label: RESX.Venue.Parking,
    currentValue: currentVenue.parking,
    existingValue: existingVenue.parking,
    sourceValue: sourceVenue.parking,
    isEmpty: (v: string) => isNullOrEmptyString(v),
    render: (v: string) => <span>{v}</span>,
    onSourceClick: () => setCurrentVenue({
      ...currentVenue,
      parking: sourceVenue.parking,
    }),
    onExistingClick: () => setCurrentVenue({
      ...currentVenue,
      parking: existingVenue.parking,
    }),
  }, {
    key: "gearAccess",
    label: RESX.Venue.GearAccess,
    currentValue: currentVenue.gearAccess,
    existingValue: existingVenue.gearAccess,
    sourceValue: sourceVenue.gearAccess,
    isEmpty: (v: string) => isNullOrEmptyString(v),
    render: (v: string) => <span>{v}</span>,
    onSourceClick: () => setCurrentVenue({
      ...currentVenue,
      gearAccess: sourceVenue.gearAccess,
    }),
    onExistingClick: () => setCurrentVenue({
      ...currentVenue,
      gearAccess: existingVenue.gearAccess,
    }),
  }, {
    key: "power",
    label: RESX.Venue.Power,
    currentValue: currentVenue.power,
    existingValue: existingVenue.power,
    sourceValue: sourceVenue.power,
    isEmpty: (v: string) => isNullOrEmptyString(v),
    render: (v: string) => <span>{v}</span>,
    onSourceClick: () => setCurrentVenue({
      ...currentVenue,
      power: sourceVenue.power,
    }),
    onExistingClick: () => setCurrentVenue({
      ...currentVenue,
      power: existingVenue.power,
    }),
  }, {
    key: "lighting",
    label: RESX.Venue.Lighting,
    currentValue: currentVenue.lighting,
    existingValue: existingVenue.lighting,
    sourceValue: sourceVenue.lighting,
    isEmpty: (v: string) => isNullOrEmptyString(v),
    render: (v: string) => <span>{v}</span>,
    onSourceClick: () => setCurrentVenue({
      ...currentVenue,
      lighting: sourceVenue.lighting,
    }),
    onExistingClick: () => setCurrentVenue({
      ...currentVenue,
      lighting: existingVenue.lighting,
    }),
  }, {
    key: "dressingRooms",
    label: RESX.Venue.DressingRooms,
    currentValue: currentVenue.dressingRooms,
    existingValue: existingVenue.dressingRooms,
    sourceValue: sourceVenue.dressingRooms,
    isEmpty: (v: string) => isNullOrEmptyString(v),
    render: (v: string) => <span>{v}</span>,
    onSourceClick: () => setCurrentVenue({
      ...currentVenue,
      dressingRooms: sourceVenue.dressingRooms,
    }),
    onExistingClick: () => setCurrentVenue({
      ...currentVenue,
      dressingRooms: existingVenue.dressingRooms,
    }),
  }, {
    key: "noiseRestrictions",
    label: RESX.Venue.NoiseRestrictions,
    currentValue: currentVenue.noiseRestrictions,
    existingValue: existingVenue.noiseRestrictions,
    sourceValue: sourceVenue.noiseRestrictions,
    isEmpty: (v: string) => isNullOrEmptyString(v),
    render: (v: string) => <span>{v}</span>,
    onSourceClick: () => setCurrentVenue({
      ...currentVenue,
      noiseRestrictions: sourceVenue.noiseRestrictions,
    }),
    onExistingClick: () => setCurrentVenue({
      ...currentVenue,
      noiseRestrictions: existingVenue.noiseRestrictions,
    }),
  }]
});
